import { Component, Inject, OnInit } from '@angular/core';
import { TransactionModel } from './related-companies.model';
import { BankAccountModel } from '../../../finanzas/bancos/bankaccount.model';
import { consts } from '../../../../consts';
import { BankAccountService } from '../../../finanzas/bancos/bankaccount.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { Utils } from '../../../../shared/utils';
import { RelatedCompaniesListComponent } from './related-companies-list.component';
import { RelatedCompaniesService } from './related-companies.service';
import { Efectivo } from '../../../../models/finanzas/efectivo/efectivo.model';
import { EfectivoService } from '../../../../services/finanzas/efectivo/efectivo.service';
import { PartnersService } from '../partners/partners.service';
import { PartnersModel } from '../partners/partners.model';
import { Option } from '../../../../shared/models/option.model';

@Component({
    selector: 'app-related-companies-form-transactions',
    templateUrl: './related-companies-form-transactions.component.html',
    styleUrls: ['./related-companies-form-transactions.component.css'],
    standalone: false
})
export class RelatedCompaniesFormTransactionsComponent implements OnInit {
  public partnerSelected = this.data['PartnerSelected'];
  public isContribution: boolean = this.data.isContribution;
  public transactionModel: TransactionModel = new TransactionModel();
  public depositSaved: boolean = false;
  public ready: boolean = false;
  public paided: boolean = false;
  public isEditMode: boolean = false;
  public list: boolean = false;

  public billMethods = [
    consts.TYPEPAY_CASH,
    consts.TYPEPAY_BANKTRANSFERENCE,
    consts.TYPE_SOCIO,
  ];

  public bankAccounts: BankAccountModel[] = [];
  public dataSource: TransactionModel[] = [];
  public headerTable: any[] = [
    { field: 'date', title: 'Fecha', cell: (row) => `${new Date(row.date).toLocaleDateString()}`, class: (row) => `` },
    { field: 'amount', title: 'Cantidad', cell: (row) => `${row.amount}  `, class: (row) => `` },
    { field: 'typePay', title: 'Método de pago', cell: (row) => row.typePay ? `${row.typePay}` : '', class: (row) => `` },
    { field: 'bankAccountInfo', title: 'Banco / Tarjeta', cell: (row) => row.bankAccountInfo ? `${row.bankAccountInfo}` : '', class: (row) => `` },
    { field: 'transactionType', title: 'tipo de transacción', cell: (row) => `${row.transactionType ? 'Aportación' : 'Devolución'}  `, class: (row) => '' }
  ];

  public invalidDate: boolean = false;
  public invalidAmount: boolean = false;
  public invalidTypePay: boolean = false;
  public invalidBankAccount: boolean = false;
  public invalidPaymentCard: boolean = false;

  public efectivoList: Efectivo[] = [];
  public sociosList: PartnersModel[] = [];

  public get typePayOptions(): Option[] {
    return this.billMethods.map(method => ({ label: method, value: method }));
  }

  public get efectivoOptions(): Option[] {
    return this.efectivoList.map(item => ({ label: item.nombre, value: item.uid }));
  }

  public get bankAccountOptions(): Option[] {
    return this.bankAccounts.map(item => ({ label: `${item.bank} - ${item.iban}`, value: item.uid }));
  }

  constructor(
    public dialogRef: MatDialogRef<RelatedCompaniesListComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public snackBar: MatSnackBar,
    public relatedCompaniesService: RelatedCompaniesService,
    public bankAccountService: BankAccountService,
    private efectivoService: EfectivoService,
    private partnersService: PartnersService,
  ) { }

  ngOnInit(): void {
    this.efectivoService.list()
      .then(listadoEfectivos => {
        this.efectivoList = listadoEfectivos
      });

    this.partnersService.list()
      .then(response => {
        this.sociosList = response
      });

    this.bankAccountService.getList()
      .then(bankAccounts => {
        this.bankAccounts = bankAccounts.list;
        this.ready = true;
      });
    this.getData();
  }

  public pay(): void {
    this.transactionModel.RelatedCompaniesId = this.data.uid;

    let noError: boolean = true;

    // Validations
    if (this.transactionModel.date == null) {
      noError = false;
      this.invalidDate = true;
    }

    if (this.transactionModel.amount == null || this.transactionModel.amount <= 0) {
      noError = false;
      this.invalidAmount = true;
    }

    if (this.transactionModel.typePay == null) {
      noError = false;
      this.invalidTypePay = true;
    }

    if (this.transactionModel.typePay === consts.TYPEPAY_BANKTRANSFERENCE) {

      if (this.transactionModel.bankAccountsUid == null) {
        noError = false;
        this.invalidBankAccount = true;
      }
    }

    if (this.transactionModel.typePay === consts.TYPEPAY_CASH) {
      this.transactionModel.commissions = 0;
      this.transactionModel.bankAccountsUid = consts.EMPTY_GUID;
    }

    if (this.transactionModel.typePay !== consts.TYPEPAY_CASH) {
      this.transactionModel.efectivoId = null;
    }

    if (this.transactionModel.typePay !== consts.TYPE_SOCIO) {
      this.transactionModel.partnersId = 0;
    }

    // Request
    if (noError) {
      if (this.isEditMode === false) {
        this.relatedCompaniesService.relatedCompaniesTransactionCreate(this.transactionModel)
          .then(response => {
            this.depositSaved = true;
          })
          .catch(err => {
            this.displayInfo("Ha ocurrido un error inesperado al añadir el pago");
          });
      }
      if (this.isEditMode === true) {
        this.relatedCompaniesService.relatedCompaniesTransactionUpdate(this.transactionModel)
          .then(response => {
            this.depositSaved = true;
          })
          .catch(err => {
            this.displayInfo("Ha ocurrido un error inesperado al actualizar el pago");
          });
      }
    } else {
      this.displayInfo("Compruebe que tiene los campos rellenados correctamente");
    }
  }

  public getData(): void {
    this.depositSaved = false;
    this.ready = false;
    this.paided = false;
    this.invalidDate = false;
    this.invalidAmount = false;
    this.invalidTypePay = false;
    this.invalidBankAccount = false;
    this.invalidPaymentCard = false;


    // Asignamos si es devolucion o no
    this.transactionModel.transactionType = this.data.isContribution;

    this.relatedCompaniesService.relatedCompaniesTransactionList(this.data.uid)
      .then(response => {
        this.dataSource = response;

        if (this.dataSource.length > 0) {
          this.list = true;
        }

        this.ready = true;
      })
      .catch(error => {
        this.ready = true;
      });
  }

  public allocateRemaining(): void {
    if (this.isEditMode) {
      this.transactionModel.amount = Utils.GetValueWithDecimals((this.dataSource.find(f => f.uid == this.transactionModel.uid).amount));
    }
  }

  public delete(uidParticipationDeposit: number): void {
    this.relatedCompaniesService.relatedCompaniesTransactionDelete(uidParticipationDeposit)
      .then(response => {
        this.getData();
      })
      .catch(err => {
        this.displayInfo("Ha ocurrido un error al eliminar el pago");
      });
  }

  public edit(uidParticipationDeposit: number): void {
    this.paided = false;
    this.isEditMode = true;
    this.depositSaved = false;

    this.transactionModel = this.dataSource.find(item => item.uid === uidParticipationDeposit);
  }

  public displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
  }

  public closeDialog(): void {
    this.dialogRef.close();
  }
  public trackByIndex(i: number) { return i; }

}
